// すべてのクエリパラメータを取得
const urlParams = new URLSearchParams(window.location.search);
document.addEventListener('DOMContentLoaded', function() {
    // タブのタイトルとコンテンツの処理
    ['.tab-wrap > .tab-title', '.tab-contents > .tab-content-wrap'].forEach(selector => {

        const elements = document.querySelectorAll(selector);
        let hasCurrentElement = false;

        // 各要素のdata-tab-valueをチェック
        elements.forEach(element => {
            const tabValue = element.dataset.tabValue; // 例: sex_type_men, category_tops など
            if (tabValue) {
                // data-tab-valueからパラメータ名と値を抽出 (例: sex_type_men → sex_type と men)
                const [paramName, paramValue] = tabValue.split('___');

                // URLのパラメータと一致するかチェック
                if (urlParams.get(paramName) === paramValue) {
                    element.classList.add('active');
                    hasCurrentElement = true;
                } else {
                    element.classList.remove('active');
                }
            }
        });

        // 該当がない場合は最初の要素にactiveを設定
        if (!hasCurrentElement && elements.length > 0) {
            elements[0].classList.add('active');
        }

    });
});